@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.home.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/mobile_wallet.feature.home.generated.resources/"

internal val Res.drawable.arrow_backward: DrawableResource by lazy {
      DrawableResource("drawable:arrow_backward", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_backward.xml", -1, -1),
      ))
    }

internal val Res.drawable.arrow_outward: DrawableResource by lazy {
      DrawableResource("drawable:arrow_outward", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_outward.xml", -1, -1),
      ))
    }

internal val Res.drawable.coin_image: DrawableResource by lazy {
      DrawableResource("drawable:coin_image", setOf(
        ResourceItem(setOf(), "${MD}drawable/coin_image.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("arrow_backward", Res.drawable.arrow_backward)
  map.put("arrow_outward", Res.drawable.arrow_outward)
  map.put("coin_image", Res.drawable.coin_image)
}
